import { IFileData, IFilesProps, IMyFiles, IPaginateFilters } from "../../models/pages/files";
import { actions } from "../constants/files";
import * as actionTypes from '../../models/action/files';

export function GetMyFilesAction(parameters: actionTypes.GetMyFilesParameters, spinnerId?: string, spinnerType?: any, callback?: any) : actionTypes.IGetMyFilesAction {
    return {
        parameters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_FILES,
        callback
    };
}

export function SetMyFilesAction(myFiles: IMyFiles, spinnerId?: string, spinnerType?: any, callback?: any) : actionTypes.ISetMyFilesAction {
    return {
        myFiles,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_FILES,
        callback
    };
}

export function AddMyFilesAction(fileInputKey: string, photoUploadKey: string, fileOwnerType?: number, spinnerId?: string, spinnerType?: any, callback?: any) : actionTypes.IAddMyFilesAction {
    return {
        fileInputKey,
        photoUploadKey,
        fileOwnerType,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_MY_FILES,
        callback
    };
}